import { toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const WelcomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-items: center;
  margin-bottom: ${toRem(45)};
`;

export const GreetingLine = styled.h1`
  color: var(--t-brand-fg-color, #1c1c1c);
  text-align: center;
  font-family: var(--t-title-font-family);
  font-weight: 700;
  font-style: var(--t-title-m-font-style);
  font-size: var(--t-title-s-font-size-viewport-l, 1.25rem);
  line-height: 110%;
`;

export const SubheadingLine = styled.h2`
  color: #b94600;
  font-style: normal;
  font-family: var(--t-title-font-family);
  font-size: var(--t-title-s-font-size-viewport-l, 1.25rem);
  line-height: 110%;
  font-weight: 700;
`;

export const WelcomeConent = styled.h3`
  font-family: var(--t-sub-title-font-family);
  font-weight: var(--t-sub-title-font-weight);
  color: var(--t-brand-alt-color);
  line-height: 150%;
  font-size: ${toRem(14)};
  font-weight: 500;
  width: ${toRem(281)};
  text-align: center;
`;
